import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';

@Component({
  selector: 'app-matches',
  templateUrl: './matches.component.html',
  styleUrls: ['./matches.component.scss']
})
export class MatchesComponent implements OnInit {

  isLoading = true;
  message;
  studentId;

  data: any;
  options: any;

  apiResponse;

  matchNameForChart;
  matchDataForChart = [];
  displayChartMatchId;

  anotherCareerValue = '';

  constructor(private dashboardService: DashboardService, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.dashboardService.getProfileTabFlag().subscribe(data => {
      if (data == 'matches') {
        this.getMatches();
      }
    });
  }

  getMatches() {
    this.isLoading = true;

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => this.studentId = (params.get('student_id')));

    this.dashboardService.studentMatches({ student_id: this.studentId }).subscribe(response => {
      this.isLoading = false;
      console.log('matches--', response);

      if (response.status == false && response.statusCode == 200) {
        this.message = response.message;
      }
      else if (response.status == true && response.statusCode == 200) {
        if (response.data.match.length == 0) {
          this.message = 'Assessments not completed yet.';
        }
        else {
          this.apiResponse = response.data;
          this.displayChartForMatch(response.data.match[0]);
        }
      }
    });
  }

  displayChartForMatch(matchData) {

    this.displayChartMatchId = matchData.id;

    this.matchNameForChart = matchData.career_domain_name;

    this.matchDataForChart = [];

    this.matchDataForChart.push({ name: 'Orientation Style', score: matchData.osmatch });
    this.matchDataForChart.push({ name: 'Interest', score: matchData.inmatch });
    this.matchDataForChart.push({ name: 'Personality', score: matchData.psmatch });
    this.matchDataForChart.push({ name: 'Aptitude', score: matchData.apmatch });
    if (this.apiResponse.basicinfo.package_id == 2) {
      this.matchDataForChart.push({ name: 'Emotional Quotient', score: matchData.eqmatch });
    }
  }

  addAnotherCareer() {
    // console.log(this.anotherCareerValue);
    const extraMatch = this.apiResponse.another_careers.find(element => element.id == this.anotherCareerValue);
    this.apiResponse.match[5] = extraMatch;
  }

}
